import PropTypes from 'prop-types';
import React from 'react';
import { Button, DialogBox, Icon } from 'xm-spark';
import { FormattedMessage } from 'react-intl';

import { XMATTERS_SIGN_OUT_URL } from 'xm-constants/urls';
import style from './SessionTimeoutDialog.module.scss';

export const redirect = () => {
  let signInUrl = document.cookie.replace(
    /(?:(?:^|.*;\s*)alarmpoint.signon.cookie\s*=\s*([^;]*).*$)|^.*$/,
    '$1',
  );
  if (!signInUrl) {
    signInUrl = XMATTERS_SIGN_OUT_URL;
  }
  window.localStorage.setItem('xmLoginState', 'LOG_OUT');
  window.location.href = signInUrl;
};

export default function SessionTimeoutDialog(props) {
  const { isOpen } = props;

  return (
    <DialogBox
      classes={{
        content: style.dialogContent,
        backdrop: style.dialogBackdrop,
      }}
      isOpen={isOpen}
      onClose={redirect}
      titleText={<FormattedMessage id="NOT_LOGGED_IN" />}
      rightButtons={
        <Button onClick={redirect}>
          <Icon type="/static/images/icons/return18.gif" />
          <FormattedMessage id="RETURN_TO_LOGIN" />
        </Button>
      }
    >
      <Icon type="/static/images/icons/login32.gif" />
      <FormattedMessage id="SESSION_EXPIRED" />
    </DialogBox>
  );
}

SessionTimeoutDialog.propTypes = {
  isOpen: PropTypes.bool,
};

SessionTimeoutDialog.defaultProps = {
  isOpen: false,
};

SessionTimeoutDialog.displayName = 'SessionTimeoutDialog';
